var _rect, _rect2, _path, _circle, _circle2, _circle3, _ellipse, _ellipse2, _circle4, _circle5, _rect3, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterBlobMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 294,
    viewBox: "0 0 375 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 234,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3933_36035)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 293.229,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3933_36035)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7214 233.594C21.7214 260.49 -0.245461 282.399 -27.474 282.399C-54.7025 282.399 -76.6693 260.49 -76.6693 233.594C-76.6693 206.698 -54.7025 184.789 -27.474 184.789C-0.245461 184.789 21.7214 206.698 21.7214 233.594Z",
    stroke: "black",
    strokeWidth: 18.5365
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1385,
    cy: 14.1385,
    r: 14.1385,
    transform: "matrix(-0.186751 -0.982407 -0.982407 0.186751 33.0601 144.401)",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7116,
    cy: 28.7116,
    r: 28.7116,
    transform: "matrix(0.894157 -0.447754 -0.447754 -0.894157 33.9277 204.58)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.857,
    cy: 138.089,
    r: 11.8292,
    transform: "rotate(95.7089 102.857 138.089)",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 461.046,
    cy: 338.568,
    rx: 36.6705,
    ry: 122.35,
    transform: "rotate(114.056 461.046 338.568)",
    stroke: "black",
    strokeWidth: 20.8333
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 284.187,
    cy: 367.165,
    rx: 82.2665,
    ry: 87.8981,
    transform: "rotate(95.7089 284.187 367.165)",
    stroke: "black",
    strokeWidth: 15.625
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.503,
    cy: 126.39,
    r: 11.8292,
    transform: "rotate(95.7089 100.503 126.39)",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "exclusion"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7031,
    cy: 14.7031,
    r: 11.0677,
    transform: "matrix(0.894157 -0.447754 -0.447754 -0.894157 24.5488 111.064)",
    stroke: "#AEAEAE",
    strokeWidth: 7.27082
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 375,
    fill: "#878787"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 375,
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 375,
    transform: "translate(0 -0.000488281)",
    fill: "#FFD550"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3933_36035",
    x: -110.417,
    y: 17.7674,
    width: 719.101,
    height: 464.017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2396,
    result: "effect1_foregroundBlur_3933_36035"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3933_36035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 293.229,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBlobMobile);
export default __webpack_public_path__ + "static/media/footer_blob_mobile.116e6e38a00648574ebbd538612a0eca.svg";
export { ForwardRef as ReactComponent };